import { useQuery } from "react-query";
import axios from "axios";
import https from "https";
import log from "../../utils/log";
import metaData from "../../data/metaData";
import useAuthStore from "../../states/useAuth";

const useWelcomeQuery = (url, queryKey, params = {}, enabled, props) => {
  const { user, auth } = useAuthStore();

  // Use default value for enabled if not passed
  const isEnabled = enabled !== undefined ? enabled : true;

  // Determine the url and default parameters based on the type
  const requestData = {
    ...params, // Merge custom params
  };

  return useQuery(
    queryKey, // Unique query key based on url and params
    async () => {
      log.debug(`fetch POST/${url}`);
      const res = await axios.post(`${metaData.serverURL}${url}`, requestData, {
        headers: { Authorization: auth.jwt },
        httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
      });
      return res.data;
    },
    {
      enabled: isEnabled, // Only enable if companyId is available
      staleTime: 10000,
      // onSuccess: (data) => log.debug(data),
      onError: (error) => log.error(error),
      // select: type === "codes" ? (data) => data.map((e, i) => ({ key: i, ...e })) : undefined,
      keepPreviousData: true,
      ...props,
    }
  );
};

export default useWelcomeQuery;
